<div class="bg-white rounded-lg border border-gray-200 p-8">
  <h1 class="text-2xl font-bold text-[#3abfad] mb-1">4. Contratar seguro voluntario</h1>
  <p class="text-gray-600 mb-6">Selecciona las opciones que tenemos disponible para ti.</p>

  <!-- Mensaje de protección -->
  <div class="flex items-start gap-3 mb-6">
    <span class="h-8 w-8 text-[#3abfad] flex-shrink-0 mt-1">🛡️</span>
    <p class="text-gray-700">
      Queremos que estés <span class="font-medium">protegido</span> y
      <span class="font-medium">solo pagarás</span> cuando tu deuda sea
      <span class="text-[#3abfad] font-medium">superior a $7.000</span>
    </p>
  </div>

  <!-- Opciones de seguro -->
  <div class="space-y-4">
    <!-- Seguro Desgravamen -->
    <div [class]="'border rounded-lg p-4 ' + (seguroOption === 'desgravamen' ? 'border-[#3abfad]' : 'border-gray-200')">
      <div class="flex items-start gap-3">
        <input type="radio" id="desgravamen" name="seguro" value="desgravamen" [checked]="seguroOption === 'desgravamen'" (change)="onSeguroChange('desgravamen')" class="mt-1" />
        <div class="flex-1">
          <label for="desgravamen" class="font-medium text-gray-700">Seguro Desgravamen</label>
          <p class="text-sm text-gray-500 mb-3">(0,42% del saldo deudor mensual)</p>
          <p class="text-sm text-gray-600 mb-3">
            Si falleces el saldo insoluto de tu deuda será cubierto por el seguro y no será transferido a tus
            herederos. Seguro con asistencia en fallecimiento.
          </p>
          <a href="#" class="text-[#3abfad] hover:underline flex items-center text-sm">
            Revisar condiciones y características
            <span class="ml-1 h-3 w-3">→</span>
          </a>
        </div>
      </div>
    </div>

    <!-- No deseo contratar -->
    <div [class]="'border rounded-lg p-4 ' + (seguroOption === 'no-seguro' ? 'border-[#3abfad]' : 'border-gray-200')">
      <div class="flex items-start gap-3">
        <input type="radio" id="no-seguro" name="seguro" value="no-seguro" [checked]="seguroOption === 'no-seguro'" (change)="onSeguroChange('no-seguro')" class="mt-1" />
        <label for="no-seguro" class="font-medium text-gray-700">No deseo contratar un seguro</label>
      </div>
    </div>
  </div>

  <!-- Nivel de cobertura -->
  <div class="bg-gray-50 rounded-lg p-4 mt-8">
    <div class="flex justify-between items-center">
      <div>
        <h3 class="text-gray-700 font-medium">Nivel de cobertura</h3>
        <p class="text-sm text-gray-500">Basado en los seguros seleccionados</p>
      </div>
      <div *ngIf="seguroOption === 'desgravamen'" class="flex items-center gap-2 text-[#3abfad] font-medium">
        <span class="h-6 w-6">✅</span>
        <span>Totalmente protegido</span>
      </div>
      <div *ngIf="seguroOption === 'no-seguro'" class="flex items-center gap-2 text-amber-500 font-medium">
        <span class="h-6 w-6">⚠️</span>
        <span>Sin seguro activo</span>
      </div>
    </div>
  </div>
</div> 